import { Container, Form } from 'react-bootstrap';
import styled from 'styled-components';

export const FormLayout = styled.div`
  background: white;
  min-height: 100vh;
`;

export const StyledContainer = styled(Container)`
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledResultPageContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100vw;
  padding: 20px;
`;

export const MessageText = styled.p`
  font-size: clamp(16px, 5vw, 30px); /* Ensures responsiveness */
  max-width: 600px; /* Optional: Limits text width */
  margin-bottom: 20px; /* Spacing between text and button */
`;

export const StyledForm = styled(Form)`
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
`;

export const StyledFormGroup = styled(Form.Group)`
  background-color: #E5E4E2;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.4);
  padding: 20px;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 18px;
`;

export const StyledHeader = styled.div`
  background-color: White;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.4);
  font-weight: bold;
  padding: 20px;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 18px;
`;

export const QAblock = styled.div`
  width: 100%;
  padding-bottom: 10px;
  margin: auto;
`;

export const StyledFormLabel = styled(Form.Label)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ErrorFormTextMsg = styled(Form.Text)`
  color: red;
  display: flex;
  align-items: center;
`;